import { useEffect } from 'react';

import { useContextNavigate } from '../../shared/hooks/use-context-navigate';

export interface EventDate {
    method: string;
    transactionId: string;
}

export function useMessageHandler(latestTransactionId: string) {
    const navigate = useContextNavigate();

    useEffect(() => {
        const onMessage = (event: MessageEvent<EventDate>) => {
            const data = event.data;
            if (data.method) {
                navigate(`/cashier/${data.method}/complete/${latestTransactionId}`);
            }
        };

        window.addEventListener('message', onMessage);

        return () => {
            window.removeEventListener('message', onMessage);
        };
    }, [latestTransactionId, navigate]);
}
